<template>
  <!-- Fallback content if JavaScript is disabled -->
  <noscript>
    <div class="p-3" v-html="getDescription"></div>
  </noscript>
  
  <div class="inherit-style">
    <van-tabs v-model:active="active" :ellipsis="true" :shrink="$device.isDesktop" line-height="0"
              title-active-color="#000" @change="onChangeTab">
      <van-tab v-for="item in getTabs" :id="item.title" :name="item.title" :title="item.title">
        <text-truncate :lines="7">
          <div class="m-3" v-html="item.description"></div>
          <div class="w-full py-4">
            <embed-video v-if="showVideo && $device.isDesktop" :fixedHeight="true" :videoUrl="product?.video_url"/>
          </div>
        </text-truncate>

        <catalog-images v-if="$device.isDesktop" :product="product"/>

      </van-tab>

      <van-tab id="specifications" :title="$t('product.specifications')" name="specifications">
        <div class="m-3">
          <label-with-value v-for="(item, index) in product?.product_attributes?.attributes"
                            :class="{ 'bg-magnolia': index % 2 !== 0 }"
                            :label="Object.keys(item)[0]"
                            :value="Object.values(item)[0]" class="p-2 rounded-sm">
          </label-with-value>
        </div>
      </van-tab>

      <van-tab v-if="$device.isDesktop" id="reviews"
               :title="$t('product.reviews.reviews', {review_total: props.reviews?.review_total})"
               name="reviews">
        <div class="m-3">
          <slot name="reviews"/>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script setup>
import EmbedVideo from "@/components/product/Video";
import LabelWithValue from '@/components/common/LabelWithValue';
import TextTruncate from '@/components/common/TextTruncate';
import {TRACKERS} from "@/constants/events";
import {track} from "@/composables/useTrackEvent";
import CatalogImages from "@/components/product/CatalogImages";

const props = defineProps({
  product: {
    type: Object,
    default: () => {
    }
  },
  reviews: {
    type: Object,
    default: () => {
    }
  },
})

const active = ref('description')

const getTabs = computed(() => props.product?.descriptions ?? [])
const getDescription = computed(() => getTabs.value.length ? getTabs.value[0]?.description : '')
const showVideo = computed(() => props?.product?.video_url)

const onChangeTab = (tabName) => {
  track(TRACKERS.PDP_MORE_PRODUCT_DETAILS, {eventAction: tabName, product: props.product})
}
</script>